<template>
 
  <div id="Vue"  >
 
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
    <el-tab-pane label="chatGPT 智能问答" name="first">
	
	  <el-form    ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
	  <el-form-item label="问题:">
		  <el-input v-model="form.keywords" class="input-with-select" @keyup.enter.native="onSubmit" style="width:600px">
 
		  </el-input>
	  </el-form-item>  
 
	  
	  <el-form-item>
		<el-button type="primary" :loading="loading" @click="onSubmit" >提交 </el-button>
	  </el-form-item>
	  </el-form>
	
	
	</el-tab-pane>
 
     
  </el-tabs>
    
 
  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  v-loading="loading" >
 
  <el-input v-model="form.results" type="textarea"
  :autosize="{ minRows: 20, maxRows: 200}"> </el-input>
  
   <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
 
 
 				
  </div> 
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
			activeName: 'first',
	    	componentName: 'info',
			ip_address: '',
		    userInfo: {},
			page: 1,
			size:10,
			total: 0,
			user_id: 0,
			loading: false,
			login_state : false,
			check_code: 100,
			check_state: 0,
			check_info: '',
			email: '',
			status:true,
            tableData: [],
			form:{ keywords:'',  
				   type:'code',
				   results: '',
				 }, 
			}  
        },
        methods: {
			handlePageChange(val) {
				this.page = val;
 
				this.getInfo()
			},	
		    onSubmit(){
		 	  if (this.form.keywords == ''){
				    this.$message({
							message: '不能为空 ! ',
							type: 'warning'
							});
				    return;
				}
                this.check_state = 1;	 		    
			    this.email = this.form.email;
				this.getInfo();
				},
			handleClick(tab, event){
			    this.check_state = 0;
			},
			getInfo(){
				let that = this;  
					 				 
				that.loading = true; 
				  $.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id,    
							  keywords:that.form.keywords,
							  ip: that.ip_address,
							  
							  },
					  url:"https://www.myferp.com/admin/chatgpt/answer", //"http://127.0.0.1:8362/admin/chatgpt/answer",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
					      that.loading = false;
						  if (data.errno > 0){
						     that.$message({
							   message:  data.errmsg,
							   type: 'warning'
							   });
							   return;
							   }
						  console.log(JSON.stringify(data));
						  console.log(data.data.choices[0].text ); 						  
 
                          that.form.results = data.data.choices[0].text; //JSON.stringify(data); 
						  					  
						  }
					  });
		    },
			
 
 

		},
        mounted() {   
				let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);    
				let info = {}; 
				if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				    info = JSON.parse(userInfo);
				    this.user_id = info.id;  
					}
				var xmlHttp = new XMLHttpRequest();
				xmlHttp.open('GET', 'https://api.ipify.org/', false);
				xmlHttp.send(null);
			    this.ip_address = xmlHttp.responseText;
				console.log('ip address:' + this.ip_address);
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/chatGPT.vue